import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { FeaturedCategoryDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/featuredcategory/featuredcategorydto';
import { FeaturedCategoriesResponse } from 'src/com/sixdee/crbtportal/core/api/featuredcategories/featuredcategoriesresponse';
import { FeaturedCategoriesRequestImpl } from 'src/com/sixdee/crbtportal/core/api/featuredcategories/featuredcategoriesrequest';
import { ToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { SearchToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/searchtone/searchtonedto';
import { SearchToneResponse } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtoneresponse';
import { SearchToneRequestImpl } from 'src/com/sixdee/crbtportal/core/api/search/searchtone/searchtonerequest';
// import { TextTransform } from '../../../toolkit/texttransform/texttransform';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { FeaturedCategoryComponent } from './featuredcomponent';

export interface FeaturedCategoryAPIModel extends APIModel
{
    getFeaturedCategories(): void;
    getFeaturedCategoriesForJustForYou(id: string, title: string): void;
}

export class FeaturedCategoryAPIModelImpl extends APIModelImpl implements FeaturedCategoryAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    getFeaturedCategories(): void 
    { 
        //  let featuredCategoryDto = new FeaturedCategoryDtoImpl();
        //  featuredCategoryDto.setIdentifier("NewReleases");
        //  featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.new_releases));
        //  featuredCategoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
        //  featuredCategoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
 
        //    this.getAPIProcesssorFactory().getFeaturedCategoriesAPIProcessorFactory()
        //              .getFeaturedCategories()
        //           .success((featuredCategoriesResponse: FeaturedCategoriesResponse)=>
        //           {
        //             featuredCategoryDto.setListOfTones(featuredCategoriesResponse.getFeaturedCategoryDto().getListOfTones().slice(0, 8));
        //              this.getAPIModelHandler().onSuccess(featuredCategoriesResponse.getAPIFeature(), 
        //              featuredCategoriesResponse.getDescription(), featuredCategoryDto);
        //           })
        //           .failure((featuredCategoriesResponse : FeaturedCategoriesResponse)=>
        //           {
        //               this.getAPIModelHandler().onFailure(featuredCategoriesResponse.getAPIFeature(), 
        //               featuredCategoriesResponse.getDescription(), undefined);
        //           })
        //           .execute(new FeaturedCategoriesRequestImpl(featuredCategoryDto));
        
        // this.getFeaturedCategoriesForJustForYou("JUST_FOR_YOU", "Just For You");
        // this.getAPIModelHandler().onSuccess(APIFeatures.FEATURED_CATEGORIES, 
        //              "", this.getFeatured3("New Releases"));
        
        let featuredCategories = decodeURI(this.getContext().getConfigurationSettings()
        .getPropertyBasedOnLanguage("FeaturedCategory")).split("|");
        
        (this.getAPIModelHandler() as FeaturedCategoryComponent).setFeaturedCategories(featuredCategories.length);

        let featuredCategoryMap: Map<string, string> = new Map<string, string>();
        featuredCategories.forEach((categories: string) =>
        {
            console.log("-------featuredCategories: " + categories);
            let releases = categories.split(",");

            console.log("------releasestitle" + releases[1]);
            console.log("------releasesid" + releases[0]);
            console.log("-------------------------------------");
            featuredCategoryMap.set(releases[0], releases[1]);
            this.getFeaturedCategoriesForJustForYou(releases[1], releases[0]);
        });

        (this.getAPIModelHandler() as FeaturedCategoryComponent).setFeaturedCategoryMap(featuredCategoryMap);
        // let newReleases = featuredCategories[0].split(",");
        // let trending = featuredCategories[1].split(",");
        // let love = featuredCategories[2].split(",");
        // let pop = featuredCategories[3].split(",");
        
        // this.getFeaturedCategoriesForJustForYou(newReleases[1], newReleases[0]);
        // this.getFeaturedCategoriesForJustForYou(trending[1], trending[0]);
        // this.getFeaturedCategoriesForJustForYou(love[1], love[0]);
        // this.getFeaturedCategoriesForJustForYou(pop[1], pop[0]);
        // this.getProfileTunes();
        // let bestOfMonth = topCharts[2].split("|");
        // let bestOfWeek = topCharts[4].split("|");
        // let mostLiked = topCharts[6].split("|");
        // this.getTopCharts(+bestOfMonth[0], TextTransform.convertToCaptialize(bestOfMonth[1]));
        // this.getTopCharts(+bestOfWeek[0], TextTransform.convertToCaptialize(bestOfWeek[1]));
        // this.getTopCharts(+mostLiked[0], TextTransform.convertToCaptialize(mostLiked[1]));
        
        
        // this.getAPIModelHandler().onSuccess(APIFeatures.FEATURED_CATEGORIES, 
        //                     "", this.getFeatured3("Best Of Month"));
        // this.getAPIModelHandler().onSuccess(APIFeatures.FEATURED_CATEGORIES, 
        //                         "", this.getFeatured3("Best Of Week"));
        // this.getAPIModelHandler().onSuccess(APIFeatures.FEATURED_CATEGORIES, 
        //                             "", this.getFeatured3("Most Liked"));
    
        
    }   

    getTopCharts(categoryId: number, identifier: string)
    {
        console.log("----id: " + categoryId);
        console.log("----identifier: " + identifier);
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(8);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        // searchToneDto.setSearchKey(""); 
        searchToneDto.setCategoryId(categoryId);
        searchToneDto.setSortBy("Order_By");
        searchToneDto.setAlignBy("ASC");
        searchToneDto.setPageNo(0);
        searchToneDto.setSearchLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getSearchTone()
        .success((searchToneResponse: SearchToneResponse)=>
        {
            let featuredCategoryDto = new FeaturedCategoryDtoImpl();
            featuredCategoryDto.setTitle(identifier);
            featuredCategoryDto.setListOfTones(searchToneResponse.getListOfSearchToneDtos().getListOfTones().slice(0, 8));

            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), featuredCategoryDto);

         })
        .failure((searchToneResponse : SearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
           searchToneResponse.getDescription(), undefined);
         })
        .execute(new SearchToneRequestImpl(searchToneDto));
    }

    getFeaturedCategoriesForJustForYou(id: string, title: string): void 
    {
        console.log("getFeaturedCategoriesForJustForYou() invoked");

         let featuredCategoryDto = new FeaturedCategoryDtoImpl();
         featuredCategoryDto.setIdentifier(id);
         featuredCategoryDto.setTitle(title);
         featuredCategoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn() === "" ? "0" : this.getContext().getUserContext().getMsisdn());
         featuredCategoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
 
         this.getAPIProcesssorFactory().getFeaturedCategoriesAPIProcessorFactory()
                     .getFeaturedCategories()
                  .success((featuredCategoriesResponse: FeaturedCategoriesResponse)=>
                  {
                    featuredCategoryDto.setListOfTones(featuredCategoriesResponse.getFeaturedCategoryDto().getListOfTones());

                     this.getAPIModelHandler().onSuccess(featuredCategoriesResponse.getAPIFeature(), 
                     featuredCategoriesResponse.getDescription(), featuredCategoryDto); 
                  })
                  .failure((featuredCategoriesResponse : FeaturedCategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(featuredCategoriesResponse.getAPIFeature(), 
                      featuredCategoriesResponse.getDescription(), undefined);
                    
                  })
                  .execute(new FeaturedCategoriesRequestImpl(featuredCategoryDto));
    }  

    getFeaturedCategoriesForBestOfMonth(): void 
    {
        console.log("getFeaturedCategoriesForBestOfMonth() invoked");

         let featuredCategoryDto = new FeaturedCategoryDtoImpl();
         featuredCategoryDto.setIdentifier("BEST OF THE MONTH");
         featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.best_of_the_month));
         featuredCategoryDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
         featuredCategoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
 
         this.getAPIProcesssorFactory().getFeaturedCategoriesAPIProcessorFactory()
                     .getFeaturedCategories()
                  .success((featuredCategoriesResponse: FeaturedCategoriesResponse)=>
                  {
                     this.getAPIModelHandler().onSuccess(featuredCategoriesResponse.getAPIFeature(), 
                     featuredCategoriesResponse.getDescription(), featuredCategoriesResponse.getFeaturedCategoryDto()); 
                  })
                  .failure((featuredCategoriesResponse : FeaturedCategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(featuredCategoriesResponse.getAPIFeature(), 
                      featuredCategoriesResponse.getDescription(), undefined);
                    
                  })
                  .execute(new FeaturedCategoriesRequestImpl(featuredCategoryDto));
    }  

    getFeatured3(title: string)
    {
        let banner1 = new FeaturedCategoryDtoImpl();
        banner1.setTitle(title);
        banner1.setListOfTones(this.getListOfTones1());

        return banner1;
    }
    getProfileTunes(): void {
        let searchToneDto = new SearchToneDtoImpl();
        searchToneDto.setPagePerCount(1);
        searchToneDto.setLanguage(this.getContext().getUserContext().getLanguage());
        //searchToneDto.setSearchKey("Recently+Added"); 
        searchToneDto.setArtistKey("");
        searchToneDto.setSearchKey(""); 
        searchToneDto.setCategoryId(+this.getContext().getConfigurationSettings().getPropertyBasedOnLanguage("STATUSRBT"));
        searchToneDto.setSortBy("Order_By");
        searchToneDto.setAlignBy("ASC");
        searchToneDto.setPageNo(20);
        searchToneDto.setSearchLanguage(this.getContext().getUserContext().getLanguage());

        this.getAPIProcesssorFactory().getSearchToneProcessorFactory()
        .getSearchTone()
        .success((searchToneResponse: SearchToneResponse)=>
        {
            let listOfTones = searchToneResponse.getListOfSearchToneDtos().getListOfTones().map((toneDto: ToneDtoImpl) =>
            {
                toneDto.setArtistName("");
                return toneDto;
            });

            let featuredCategoryDto = new FeaturedCategoryDtoImpl();
            featuredCategoryDto.setTitle(this.getContext().getResources().getString(Strings.profile_tunes).toLocaleUpperCase());
            featuredCategoryDto.setListOfTones(listOfTones.slice(0, 8));

            this.getAPIModelHandler().onSuccess(searchToneResponse.getAPIFeature(), 
            searchToneResponse.getDescription(), featuredCategoryDto);

         })
        .failure((searchToneResponse : SearchToneResponse)=>
         {
           this.getAPIModelHandler().onFailure(searchToneResponse.getAPIFeature(), 
           searchToneResponse.getDescription(), undefined);
         })
        .execute(new SearchToneRequestImpl(searchToneDto));
    }

    private getListOfTones1()
    {  let tone1 = new ToneDtoImpl();
        tone1.setId("9");
        tone1.setToneName("1234rsva");
        tone1.setArtistName("987ytrfgbnmk");
        tone1.setImgPath("http://placehold.it/120x120&text=image9");
        tone1.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone2 = new ToneDtoImpl();
        tone2.setId("10");
        tone2.setToneName("1234rsva");
        tone2.setArtistName("987ytrfgbnmk");
        tone2.setImgPath("http://placehold.it/120x120&text=image10");
        tone2.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_1MG.mp3");

        let tone3 = new ToneDtoImpl();
        tone3.setId("11");
        tone3.setToneName("1234rsva");
        tone3.setArtistName("987ytrfgbnmk");
        tone3.setImgPath("http://placehold.it/120x120&text=image11");
        tone3.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_5MG.mp3");

        let tone4 = new ToneDtoImpl();
        tone4.setId("12");
        tone4.setToneName("1234rsva");
        tone4.setArtistName("987ytrfgbnmk");
        tone4.setImgPath("http://placehold.it/120x120&text=image12");
        tone4.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone5 = new ToneDtoImpl();
        tone5.setId("13");
        tone5.setToneName("1234rsva");
        tone5.setArtistName("987ytrfgbnmk");
        tone5.setImgPath("http://placehold.it/120x120&text=image13");
        tone5.setToneUrl("https://file-examples.com/wp-content/uploads/2017/11/file_example_MP3_700KB.mp3");

        let tone6 = new ToneDtoImpl();
        tone6.setId("14");
        tone6.setToneName("1234rsva");
        tone6.setArtistName("987ytrfgbnmk");
        tone6.setImgPath("http://placehold.it/120x120&text=image14");

        let tone7 = new ToneDtoImpl();
        tone7.setId("15");
        tone7.setToneName("1234rsva");
        tone7.setArtistName("987ytrfgbnmk");
        tone7.setImgPath("http://placehold.it/120x120&text=image15");

        let tone8 = new ToneDtoImpl();
        tone8.setId("16");
        tone8.setToneName("1234rsva");
        tone8.setArtistName("987ytrfgbnmk");
        tone8.setImgPath("http://placehold.it/120x120&text=image16");

        return [tone1, tone2, tone3, tone4, tone5, tone6, tone7, tone8];
    } 
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/featuredcategoryapimodel.ts